import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { LibraryService } from '@go-modules/services/library/library.service';
import { ActivityMenuComponent } from './activity-menu.component';
import { FeedbackHoldModule } from '@go-modules/components/feedback-hold/feedback-hold.module';
import { CollectionDestinationModule } from '@go-modules/components/library/collection-destination/collection-destination.module';
import { ActivityTaskToggleComponent } from '@go-modules/components/activity-task-toggle/activity-task-toggle.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FeedbackHoldModule,
		CollectionDestinationModule,
		ActivityTaskToggleComponent
	],
	declarations: [
		ActivityMenuComponent
	],
	exports: [
		ActivityMenuComponent
	],
	providers: [
		TranslatePipe,
		LibraryService
	]
})
export class ActivityMenuModule {}
